import { render, staticRenderFns } from "./AccountActivities.vue?vue&type=template&id=46d17362&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./AccountActivities.vue?vue&type=script&lang=js&"
export * from "./AccountActivities.vue?vue&type=script&lang=js&"
import style0 from "./AccountActivities.vue?vue&type=style&index=0&id=46d17362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d17362",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
